export const MaterialQtdMode = {
  MANUAL: 1,
  AUTOMATIC: 2,
};
